<div class="drop-down-container stylized" [ngClass]="{'disabled': block}" (clickOutsideDdown)="showOptions = false">
    <div class="combo-box" tabindex="0" (click)="showOptionsToggle()" (keypress)="onComboBoxKeyPress($event)" #comboBox>
        <ng-container *ngIf="itemTemplate && startItem; else defaultTpl" [ngTemplateOutlet]="itemTemplate"
            [ngTemplateOutletContext]="{ $implicit: selectedItem, isStart: true }">
        </ng-container>

        <ng-template #defaultTpl>
            <input class="combo-box__input" tabindex="-1" type="text"
                [value]="selectedItem ? (displayProperty ? selectedItem[displayProperty] : selectedItem) : null"
                [placeholder]="!startItem ? ('GENERAL.SELECT_ITEM' | translate) : ''" readonly>
        </ng-template>


        <div class="icons-container">
            <span class="icon-arrow-down icon" [ngClass]="{'open-icon': showOptions}"></span>
        </div>
    </div>
    <ul class="options-container" [ngClass]="{'open': showOptions && (items?.length !== 0 || loading)}"
        (scroll)="onScroll($event)">
        <li class="option" [id]="'option-'+id+'-'+i" tabindex="0" *ngFor="let item of items; let i = index"
            [ngClass]="{'isSelected': selectedItem == item}" (click)="selectItem(item)">
            <ng-container *ngIf="itemTemplate; else defaultTpl" [ngTemplateOutlet]="itemTemplate"
                [ngTemplateOutletContext]="{ $implicit: item, isStart: false }">
            </ng-container>

            <ng-template #defaultTpl>
                {{ displayProperty ? item[displayProperty] : item }}
            </ng-template>
        </li>
        <div class="loader-container" *ngIf="loading">
            <div class="loader">
            </div>
        </div>
    </ul>
</div>